import { render, staticRenderFns } from "./SelfPublishingFlowQuoteFooterDefault.vue?vue&type=template&id=ea97322c&scoped=true&"
import script from "./SelfPublishingFlowQuoteFooterDefault.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowQuoteFooterDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea97322c",
  null
  
)

export default component.exports